import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://884616dbefce74b43dd804bfa43ff4ba@o4508213602615296.ingest.us.sentry.io/4508684496076800",
  debug: false,
  environment: "production",
  release: "cd9b43ae7b3fe57d7d6656cf2a1bd0e99002f68c",
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()